import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { getStyle } from './utils.es.js';
import './InputNumber-7d93e963.js';
import './components/shared/Link.es.js';
import 'rc-select';
import '@teko-builder/icons';
import './FormItem-098fa619.js';
import './DateTimePickerMobile-749dc497.js';
import './RadioGroup-4b4abf08.js';
import './Col-475038db.js';
import { D as DSSlider } from './Slider-93041044.js';
import './Container-ca9f82d8.js';
import './Divider-600cb92e.js';
import './Ripple-abf0f8a0.js';
import { D as DsImage } from './Image-efa43cf5.js';
import './ModalHeader-a3d30e4f.js';
import './Spin-a6892495.js';
import styled from '@emotion/styled';
import { I as Image } from './Image-b56e679c.js';
import 'react';
import '@teko-builder/types/pb';
import { c as convertOptionSliderV2ToV1 } from './slider-28e133c3.js';

const Slider = (props) => {
    const { items, type, commonStyle, className } = props, sliderConfig = __rest(props, ["items", "type", "commonStyle", "className"]);
    const wrapperStyle = Object.assign({}, commonStyle);
    if (sliderConfig.slidesPerColumn && sliderConfig.slidesPerColumn > 1) {
        delete wrapperStyle.height;
    }
    return (jsx(Wrapper$1, Object.assign({ commonStyle: wrapperStyle, className: className }, { children: jsx(DSSlider, Object.assign({}, sliderConfig, { children: items.map((item, index) => {
                return (jsx(Image, Object.assign({ commonStyle: {
                        objectFit: props.crop ? 'cover' : 'contain',
                        height: commonStyle === null || commonStyle === void 0 ? void 0 : commonStyle.height,
                        width: '100%',
                    } }, item), index));
            }) })) })));
};
Slider.displayName = 'Slider';
const Wrapper$1 = styled.div(({ commonStyle }) => `
  ${getStyle(commonStyle)};
  overflow: hidden;
`);

const SliderV2 = (props) => {
    const { commonStyle, className } = props, sliderConfig = __rest(props, ["commonStyle", "className"]);
    const _a = convertOptionSliderV2ToV1(sliderConfig), { items } = _a, rest = __rest(_a, ["items"]);
    const wrapperStyle = Object.assign({}, commonStyle);
    if (rest.slidesPerColumn && rest.slidesPerColumn > 1) {
        delete wrapperStyle.height;
    }
    return (jsx(Wrapper, Object.assign({ commonStyle: wrapperStyle, className: className }, { children: jsx(DSSlider, Object.assign({}, rest, { children: items.map((item, index) => {
                return (jsx(DsImage, Object.assign({ height: commonStyle === null || commonStyle === void 0 ? void 0 : commonStyle.height, width: '100%', objectFit: props.crop ? 'cover' : 'contain' }, item), index));
            }) })) })));
};
SliderV2.displayName = 'SliderV2';
const Wrapper = styled.div(({ commonStyle }) => `
  ${getStyle(commonStyle)};
  overflow: hidden;
`);

export { Slider as S, SliderV2 as a };
